function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';
import styled from '../../_snowpack/pkg/styled-components.js';
const SVG = styled.svg.withConfig({
  displayName: "info__SVG",
  componentId: "sc-1j6zib3-0"
})([""]);

const SvgComponent = props => /*#__PURE__*/React.createElement(SVG, _extends({
  "enable-background": "new 0 0 426.667 426.667",
  version: "1.1",
  viewBox: "0 0 426.667 426.667",
  color: "#FFF"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "192",
  y: "298.67",
  width: "42.667",
  height: "42.667"
}), /*#__PURE__*/React.createElement("path", {
  d: "m213.33 0c-117.82 0-213.33 95.513-213.33 213.33s95.513 213.33 213.33 213.33 213.33-95.513 213.33-213.33-95.512-213.33-213.33-213.33zm0 388.05c-96.495 0-174.72-78.225-174.72-174.72s78.225-174.72 174.72-174.72c96.446 0.117 174.6 78.273 174.72 174.72 0 96.496-78.224 174.72-174.72 174.72z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m296.32 150.4c-10.974-45.833-57.025-74.091-102.86-63.117-38.533 9.226-65.646 43.762-65.462 83.384h42.667c2.003-23.564 22.729-41.043 46.293-39.04s41.043 22.729 39.04 46.293c-4.358 21.204-23.38 36.169-45.013 35.413-10.486 0-18.987 8.501-18.987 18.987v45.013h42.667v-24.32c45.12-11.635 72.565-57.312 61.653-102.61z"
}));

export default SvgComponent;